// Loops through featured collections and adds an incremental class to identify them then initialises a slick slider (prevents them from controlling each other)
var num = 0;
$('.featured-collection.slick').each(function(i, obj) {
  var slides_desktop = $(this).attr('data-slides-desktop');
  var slides_mobile = $(this).attr('data-slides-mobile');
  num++;
  $(this).addClass('id' + num);
  $(this).slick({
    speed: 300,
    easing: 'ease',
    slidesToShow: parseInt(slides_desktop, 10),
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor" transform="translate(100, 100) rotate(180)"></path></svg></button>',
    asNavFor: '.featured-collection-wrapper .slider_dots.id' + num,
    instructionsText: 'This carousel contains products cards featuring images, name and price information, and links to product pages. Use the Previous and Next buttons to move between slides.',
    regionLabel: 'Featured Products Carousel',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: parseInt(slides_mobile, 10)
        }
      }
    ]
  });
});
// Does the same with the dot navigation
var num = 0;
$('.featured-collection-wrapper .slider_dots').each(function(i, obj) {
  num++;
  $(this).addClass('id' + num);
  $(this).slick({
    speed: 300,
    easing: 'ease',
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    arrows: false,
    dots: false,
    asNavFor: '.featured-collection.id' + num,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '10%'
  });
});
// Queues active cards of first Featured Collection to load in order, and sets all other cards as loaded (otherwise additional collections need to wait for every card of earlier collections to load)
var num = 0;
$('.featured-collection').each(function(i, obj) {
  num++;
  $(this).addClass('id' + num);
});
$('.featured-collection.id1 .slick-active .card-wrapper').each(function(i, obj) {
  $(this).delay(i*200).queue(function() {
    $(this).addClass('loaded').dequeue();
  });
});
$('.featured-collection.id1 .slick-slide:not(.slick-active) .card-wrapper, .featured-collection:not(.id1) .card-wrapper').each(function(i, obj) {
  $(this).addClass('loaded');
});